import { getTranslateFn } from '@project44/translations-utils';

import { translations } from '../../../l10n/config';
import { PACKAGE_NAME } from '../constants/PACKAGE_NAME';

export const scopedT = () => getTranslateFn(PACKAGE_NAME, translations);
